@if (visible$ | async) {
  <div #editWrapper class="edit-wrapper">
    @if (!openedFromFeatureInfo()) {
      <div class="tm-edit-component-wrapper">
        <tm-edit [inMobilePanel]="true"></tm-edit>
      </div>
    }
    <tm-edit-dialog [inMobilePanel]="true"></tm-edit-dialog>
  </div>
}
